import { useMutation } from '@tanstack/react-query'
import { MainApi } from 'api/MainApi'

const useDeleteCleaningZone = () =>
  useMutation<void, Error, number>({
    mutationFn: MainApi.deleteCleaningZone,
  })

export default useDeleteCleaningZone
